import React, { useCallback, useMemo } from 'react';
import { Dropdown } from '@gafe/common-ui';

import { isWarranty, mapPriceBookItemToOrderItem } from '@/components/modals/SubmitOrder/constants';
import { useOrderContext, useOrderDispatch } from '@/components/modals/SubmitOrder/helpers';

import { getWarrantyByName } from '../../../OrderDetailsStep/components/Warranty/helpers';
import { ContractDetailsWrapper } from '../ContractDetailsWrapper';

import { Props } from './types';

import styles from './Warranty.module.scss';

export const Warranty = ({ allPriceBookEntries }: Props): JSX.Element | null => {
  const state = useOrderContext();
  const { isAccessProgram, isDistribution } = state;
  const dispatch = useOrderDispatch();
  const isAccessDistribution = isAccessProgram && isDistribution;

  const warranties = useMemo(
    () =>
      allPriceBookEntries
        .filter(item => isWarranty(item) && item.isProductAvailable && !item.product.isPreSelected)
        .sort((first, second) => first.product.name.localeCompare(second.product.name)),
    [allPriceBookEntries],
  );

  const handleOnChange = useCallback(
    (value: string | null) => {
      const newWarranty = getWarrantyByName(value, warranties);
      const warranty = getWarrantyByName(state.order.distributionWarranty, warranties);
      const currentOrderItems = state.visibleOrderItems;
      const filteredOrderItems = currentOrderItems.filter(
        item => item.priceBookEntry.product.portalName !== warranty?.product.portalName,
      );

      if (newWarranty) {
        const orderItem = {
          priceBookEntry: newWarranty,
          orderItem: mapPriceBookItemToOrderItem(newWarranty),
          proposalItem: null,
        };
        const orderItems = [...filteredOrderItems, orderItem];

        dispatch({
          type: 'UPDATE_VISIBLE_ORDER_ITEMS',
          payload: orderItems,
        });
      }

      dispatch({
        type: 'UPDATE_ORDER',
        payload: {
          distributionWarranty: value,
        },
      });
    },
    [dispatch, state, warranties],
  );

  if (!isAccessDistribution) {
    return null;
  }

  return (
    <ContractDetailsWrapper tabletView title="Which warranty is the homeowner purchasing?">
      <Dropdown
        classes={{ wrapper: styles.dropdown_wrapper }}
        onSelect={handleOnChange}
        placeholder="Select Warranty"
        size="medium"
      >
        {warranties.map(warranty => {
          return (
            <Dropdown.Option
              key={warranty.product.id}
              label={warranty.product.portalName || warranty.name || 'Uknown'}
            />
          );
        })}
      </Dropdown>
    </ContractDetailsWrapper>
  );
};
